const modules = import.meta.glob('./*/*.ts', { eager: true }) as Record<string, { default?: Record<string, string> }>;

const messages: Record<string, { translation: Record<string, string> }> = {};

try {
  Object.keys(modules).forEach((path) => {
    const match = path.match(/\.\/([^/]+)\/([^/]+)\.ts$/);
    if (match) {
      const [, lang] = match;
      const module = modules[path];
      
      if (!messages[lang]) {
        messages[lang] = { translation: {} };
      }
      
      if (module?.default) {
        messages[lang].translation = {
          ...messages[lang].translation,
          ...module.default
        };
      }
    }
  });
} catch (e) {
  console.warn('i18n glob resolution warning:', e);
}

export default messages;